import { useCallback } from 'react'

import { validateCustomFields } from '@user/components/CustomFields'
import type { ICustomFieldFormSetting } from '@user/store/entityFormSettings'

import type { RequiredFieldsFormModel } from '../typings'

export function useValidate(customSettings: ICustomFieldFormSetting[]) {
  return useCallback(
    (model: RequiredFieldsFormModel) =>
      validateCustomFields(model, customSettings),
    [customSettings],
  )
}
